import { jsx } from "react/jsx-runtime";
import { List } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
import makeContentInteractive from "../../util/makeSpansInteractive.esm.js";
const getExtraInstructions = (isPost) => [{
  shouldProcessNode(node) {
    return node.name === "ul" || node.name === "ol";
  },
  processNode(node, children, nodeIndex) {
    var _a, _b, _c, _d;
    const isNestedList = ((_a = node.parentNode) == null ? void 0 : _a.name) === "li";
    const isOrdered = node.name === "ol";
    const styleStr = ((_b = node.attribs) == null ? void 0 : _b.style) || "";
    const listStyleMatch = styleStr.match(/list-style-type:\s*([^;]+)/i);
    const listStyleType = listStyleMatch ? listStyleMatch[1].trim() : void 0;
    const start = isOrdered ? Number.parseInt((_c = node.attribs) == null ? void 0 : _c.start, 10) : NaN;
    const reversed = isOrdered && ((_d = node.attribs) == null ? void 0 : _d.reversed) !== void 0;
    return /* @__PURE__ */ jsx(List, { appearance: isOrdered ? "number" : "bullet", ...listStyleType && {
      listStyleType
    }, ...!Number.isNaN(start) && {
      start
    }, ...reversed && {
      reversed
    }, ...isPost && !isNestedList && {
      paddingBottom: "sm"
    }, children }, `${nodeIndex}-list-${node.name}`);
  }
}, {
  shouldProcessNode(node) {
    return node.name === "li";
  },
  processNode(node, children, nodeIndex) {
    return /* @__PURE__ */ jsx(List.Item, { style: {
      listStyleType: "inherit"
    }, children }, `${nodeIndex}-listitem-${node.name}`);
  }
}];
const WPList = ({
  innerHTML
}) => {
  const isPost = usePlacement() === "post";
  const parsedComponent = makeContentInteractive(innerHTML, {
    extraInstructions: getExtraInstructions(isPost)
  });
  return parsedComponent;
};
WPList.propTypes = {
  index: PropTypes.number,
  innerHTML: PropTypes.string
};
export {
  WPList as default
};
